import React, { useContext, useEffect } from "react";
import LoginFooter from '../../components/Footers/LoginFooter';
import AdminHeader from '../../components/Headers/AdminHeader';
import Communication from '../../components/Communication';
import { useHistory } from "react-router";
import { UserContext } from '../../context/User';

const CommunicationPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const history = useHistory();

  useEffect(() => {
    if (role !== "admin") {
      history.push("/dashboard");
    }
  }, []);

  return (
    <>  
      <AdminHeader />
      <main>
        {role === "admin" && <Communication />}
      </main>
      <LoginFooter />
    </>
  );
}

export default CommunicationPage;